import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SupporterVoice } from '#src/app/pages/actions/shared/types';

import {
	CreateSupporterComment,
	type CreateSupporterCommentMutation,
	type CreateSupporterCommentMutationVariables,
} from './createSupporterComment.graphql';
import { gqlSupporterCommentToSupporterVoice } from './types';

export async function createSupporterComment(
	petitionId: string,
	text: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<SupporterVoice> {
	const { data } = await fetch<CreateSupporterCommentMutation, CreateSupporterCommentMutationVariables>({
		query: CreateSupporterComment,
		variables: { petitionSlugOrId: petitionId, text },
		rejectOnError: true,
		batched: false,
	});

	const result = data.createPetitionSupporterComment;

	if (result.__typename === 'CreatePetitionSupporterCommentSuccess') {
		return gqlSupporterCommentToSupporterVoice(result.comment);
	}

	throw new Error('Creation failed');
}
